// removed by extract-text-webpack-plugin
module.exports = {"spacing-small":"4px","spacing-huge":"32px","thunder":"#6b6e72","this":"UniversalComposer__this___Lp9Ja","uniquePanelContent":"UniversalComposer__uniquePanelContent___2ARSO"};


//////////////////
// WEBPACK FOOTER
// ./src/chat/components/styles/UniversalComposer.css
// module id = 2111
// module chunks = 4